export default __webpack_public_path__ + "58e7bdff47986f6e6736f2b9ee235026.svg";